import Header from '@/components/header/header'
import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import { Getter, State } from 'vuex-class'

@Component({
  components: {
    Header
  }
})
export default class ChallengeInfo extends Vue {
  @Getter getUser;
  @Getter getUniversity;
  @State user;

  get fillBar () {
    let data
    if (this.getUser.challenge_accomplished_count === 0) {
      data = 'fill--0'
    } else {
      data = `fill--${this.getUser.challenge_accomplished_count}`
    }
    return data
  }

  _goBack () {
    this.$router.go(-1)
  }
}
